import React from 'react';
import { analytics, CONFIG } from 'utils';

declare global {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    interface Window {
        prerenderCloudIsServerSideRendering?: boolean;
    }
}

export const AnalyticsLoader: React.FC = ({ children }) => {
    if (!window.prerenderCloudIsServerSideRendering) {
        analytics.load(CONFIG.VITE_SEGMENT_WRITE_KEY);
    }
    return <>{children}</>;
};

export default React.memo(AnalyticsLoader);
